import { useState } from "react";
import { cn } from "@/lib/utils";
import { fmtDateTime } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { fmtAgo } from "../shared";
import { Big } from "./Light";
import { useSimple } from "./useSimple";

const TONE = { critical: "border-l-[#F92626]", high: "border-l-[#F92626]", medium: "border-l-amber-400", info: "border-l-slate-200", low: "border-l-slate-200" };

export function ActivityTab() {
  const { data, isLoading } = useSimple();
  const [all, setAll] = useState(false);
  if (isLoading || !data) return <div className="text-slate-500">Loading activity…</div>;
  const rows = all ? data.activity : data.activity.slice(0, 15);
  return (
    <div className="space-y-5" data-testid="activity-tab">
      <div><Big>What happened</Big><p className="text-sm text-slate-500">Newest first, in plain words. Every line comes from a recorded event.</p></div>
      {rows.length === 0 ? <div className="tqi-card p-10 text-center text-slate-600" data-testid="activity-empty">Nothing yet — once a Bot connects, its activity shows up here.</div> :
        <ol className="tqi-card divide-y divide-slate-100" data-testid="activity-list">{rows.map((e) => <li key={e.id} className={cn("flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 border-l-4 px-4 py-3", TONE[e.severity] || TONE.info)} data-testid={`activity-${e.id}`}><span className="text-base text-slate-800">{e.text}</span><time className="text-xs text-slate-500" title={fmtDateTime(e.at)}>{fmtAgo(e.at)}</time></li>)}</ol>}
      {data.activity.length > 15 && <Button variant="outline" className="h-11" onClick={() => setAll(!all)} data-testid="activity-more">{all ? "Show less" : `Show all ${data.activity.length}`}</Button>}
    </div>
  );
}
